// test1932
(1932 && 0);
